<template>
  <div>
    <div class="custom-div">
    <span>Data da consulta: {{ $api.Functions.FormatarDataHora(dtInclusao) }}</span>
    </div>
    <b><span>Validação documento de identificação:</span></b>
    <br><br>
    <span><b>Situação:</b> {{ obterDescricaoSituacao() }}<br> </span><br>
    <div v-show="analise.regrasPontuacao">
      <span><b>Score:</b> {{ itens.score ? itens.score : 0 }}</span><br>
      <div v-for="detalhe in detalhes" :key="detalhe.VariableId">
        <span v-if="!Array.isArray(detalhe.Value)">
          <b>{{ detalhe.VariableName }}:</b> {{ detalhe.Value }}<br>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    analise: Object
  },
  data() {
    return {
      itens: {},
      dtInclusao: null,
      situacao: null,
      detalhes: []
    }
  },
  methods: {
    alimentarObjeto() {
      const th = this

      th.dtInclusao = th.analise.dtInclusao
      th.itens = th.analise
      
      if (th.analise.regrasPontuacao)
        th.detalhes = JSON.parse(th.analise.regrasPontuacao)

      th.situacao = th.analise.regrasDecisao ? 
        (JSON.parse(th.analise.regrasDecisao)[0] && 
        JSON.parse(th.analise.regrasDecisao)[0].RuleDecision 
          ? JSON.parse(th.analise.regrasDecisao)[0].RuleDecision.Label 
          : th.analise.status) 
        : th.analise.status
    },
    obterDescricaoSituacao() {
      const th = this

       if (th.situacao && th.situacao.toUpperCase() === "AGUARDANDO RETORNO WEBHOOK.")
        return 'Aguardando retorno do fornecedor.'

      return th.situacao
    }
  }
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.custom-div{
  background-color: rgb(243, 236, 236);
  padding: 8px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between
}

.v-stepper__wrapper{
  padding-bottom: 30px;
}
</style>
